import React, { Component } from 'react';
import { CustomPagination } from './styles';

interface IProps {
  total?: number;
  pageSize?: number;
  onChange?: any;
  current?: number;
}

export default class Tab extends Component<IProps> {
  render() {
    return <CustomPagination {...this.props} />;
  }
}
